import Pagination, { PaginationType } from "components/pagination";

export interface tableHeader {
  header_text: string | React.JSX.Element;
  narrow: boolean;
  wrap: boolean;
}

export default function Table(
  headers: tableHeader[],
  tableBody: React.JSX.Element,
  pagination: boolean,
  paginationInfo?: PaginationType
) {
  return (
    <div className="col-12">
      <div className="card rounded-2xl">
        <div
          className="table-responsive rounded-2xl"
          style={window.location.pathname.includes("/reports") ? { maxHeight: window.innerHeight - 110 } : undefined}
        >
          <table className="table table-vcenter card-table" style={{ position: "relative" }}>
            <thead>
              <tr style={{ position: "sticky", top: 0, backgroundColor: "var(--tblr-card-bg)", zIndex: 1 }}>
                {headers.map((header, index) => (
                  <th
                    className={`${header.narrow && "w-1"} ${header.wrap && "text-wrap"}`}
                    style={
                      window.location.pathname.includes("/reports")
                        ? { borderRightWidth: "var(--tblr-border-width)", fontWeight: 700, textAlign: "center" }
                        : undefined
                    }
                    key={index}
                  >
                    {header.header_text}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>{tableBody}</tbody>
          </table>
        </div>
        {pagination && (
          <Pagination total={paginationInfo?.total || 0} updateInfo={paginationInfo?.updateInfo || (async () => {})} />
        )}
      </div>
    </div>
  );
}
